<template>
    <div class="operation-help-standalone"><operation-help namespace="stock" help-key="material-stored" /></div>
    <el-tabs type="border-card" v-model="tabName">
        <el-tab-pane name="workform">
            <template #label>
                <span> 单据信息 </span>
            </template>
            <div style="width: calc( 100% - 10px ); margin:0 auto;padding:5px;">
                <h4 class="form-title">金料采购单</h4>
                <el-form :model="forms" ref="forms">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                            <el-form-item label="所属公司" label-width="100px">
                                <el-tree-select ref="companys" v-model="forms.companyId" :data="companys" check-strictly
                                    @change="companyChange();" :render-after-expand="false"
                                    :disabled="!!id" />
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="16" :xl="16">
                            <el-form-item label="采购部门" label-width="100px">
                                <el-select v-model="forms.departments" multiple collapse-tags-tooltip
                                    style="width: 100%" placeholder="" filterable :disabled="!!id"
                                    @change="materialChange();">
                                    <el-option v-for="dd in departments" :key="dd.departmentName"
                                        :label="dd.departmentName" :value="dd.id" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="!id">
                            <el-form-item label="关联付款单号" prop="choosePayBill">
                                <el-autocomplete style="width: 95%" v-model="choosePayBill.value"
                                    :disabled="!forms.companyId" :fetch-suggestions="searchPayBillAsync"
                                    placeholder="请输入付款单号" @select="choosePayBillHandle">
                                </el-autocomplete>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                            <el-form-item label="付款单号" label-width="100px">
                                <el-input v-model="forms.payBillCode" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                            <el-form-item label="付款单金额" label-width="100px">
                                <el-input v-model="forms.payBillAmount" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                            <el-form-item label="操作类型" label-width="100px">
                                <el-select v-model="forms.billType" placeholder="操作类型" disabled>
                                    <!-- :disabled="!!id"  @change="billTypeChange();" -->
                                    <el-option v-for="item in dict.billTypes" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                            <el-form-item label="单据编号" label-width="100px">
                                <el-input v-model="forms.billCode" placeholder="单据编号" disabled></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                            <el-form-item label="单据时间" label-width="100px">
                                <el-input v-model="forms.billDate" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                            <el-form-item label="操作人员" label-width="100px">
                                <el-input v-model="forms.userName" disabled style="width:150px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                            <el-form-item label="采购总金重" label-width="100px">
                                <el-input-number v-model="forms.totalNumber" :min="0" :max="10000000"
                                    @change="materialChange()" placeholder="0.00" :disabled="!!id"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                            <el-form-item label="采购金单价" label-width="100px">
                                <el-input-number v-model="forms.unitPrice" :min="0" :max="10000000"
                                    @change="materialChange()" placeholder="0.00" :disabled="!!id"></el-input-number>
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                            <el-form-item label="金料工厂" label-width="100px">
                                <el-select v-model="forms.factoryName" placeholder="请选择金料的来源工厂信息" filterable
                                    :disabled="!!id || (forms.factoryName && (forms.departments || []).length > 0)">
                                    <el-option v-for="item in dict.factorys" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                            <el-form-item label="金料材质" label-width="100px">
                                <!-- <el-input v-model="forms.materialName" placeholder="单据编号" disabled></el-input> -->
                                <el-select v-model="forms.materialCode" placeholder="请选择" @change="materialChange()"
                                    :disabled="!!id">
                                    <el-option v-for="item in dict.metals" :key="item.id"
                                        :label="item.name + '（' + item.value + '）'" :value="item.name"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-form-item label="操作备注" label-width="100px">
                                <el-input v-model="forms.reason" style="width: 90%;" :disabled="!!id"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="12" :lg="18" :xl="18" style="text-align: left;">
                            <!-- 不是这个流程，只有采购金料，直接金料入库的流程。 -->
                            <!-- <el-steps style="max-width: 400px; padding-top: 18px;padding-bottom: 5px; background: #fff;"
                  :active="((forms.status || 0) + 1)" finish-status="success" simple>
                  <el-step title="金料采购" />
                  <el-step title="工厂送料" />
                  <el-step title="表单确认" />
                </el-steps> -->
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6" style="text-align: right; margin-top: 10px;">
                            <el-button @click="$router.go(-1)">返回</el-button>
                            <el-button type="primary" @click="saveEvent()" style="margin-right: 15px;"
                                v-if="!id || forms.status == 0">保存库存</el-button>
                            <el-button type="primary" @click="fundEvent()" style="margin-right: 15px;"
                                v-if="forms.status == 1">财务确认</el-button>
                        </el-col>
                    </el-row>
                </el-form>
                <el-table :data="materials" border stripe size="small" style="margin: 15px auto; width: 100%;">
                    <el-table-column type="index" align="center" label="序号" width="45"> </el-table-column>
                    <el-table-column prop="billType" label="单据类型" width="100" show-overflow-tooltip> </el-table-column>
                    <!-- <el-table-column prop="memo" label="摘要" width="100" show-overflow-tooltip> </el-table-column> -->
                    <el-table-column prop="materialCode" label="材质编号" width="80" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="materialName" label="材质名称" width="80" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="factoryName" label="工厂名称" width="160">
                        <template #default="scope">
                            <el-input v-model="scope.row.factoryName" disabled></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="departmentName" label="渠道" width="90" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="unitPrice" label="本次单价" width="75"> </el-table-column>
                    <el-table-column prop="stockNumber" label="操作克重/数量" width="180">
                        <template #default="scope">
                            <el-input-number v-model="scope.row.stockNumber" :min="-100000" :max="10000000"
                                @change="materialChange()" placeholder="0.00" :disabled="!!id"> </el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stockPrice" label="总价" width="100"> </el-table-column>

                    <el-table-column prop="remainNumber" label="结余数" width="110">
                        <template #header>
                            <p v-if="!id">操作前结余数</p>
                            <p v-if="id">操作后结余数</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remainPrice" label="结余价" width="110">
                        <template #header>
                            <p v-if="!id">操作前结余价</p>
                            <p v-if="id">操作后结余价</p>
                        </template>
                    </el-table-column>

                    <el-table-column prop="remark" label="备注" width="220"  v-if="!!id"> </el-table-column>
                </el-table>
            </div>
        </el-tab-pane>
        <!-- <el-tab-pane name="fileform">
        <template #label>
          <span> 表单附件 </span>
        </template>
  
        <div id="fileform">
          <el-upload
            :action="apiUrl + 'BaseUploader/Basic?dataType=' + opts.formType + '&dataID=' + (opts.uniqueCode || forms.billCode) + '&fileType=form&fileCode=' + opts.billCode"
            list-type="picture-card" :on-success="uploadHandleSuccess" :on-remove="removeHandle"
            :on-preview="previewHandle" :before-upload="uploadHandleBefore" :file-list="opts.files">
            <el-icon>
              <Plus />
            </el-icon>
            <template #file="{ file }">
              <img v-if="file.ext == 'jpg' || file.ext == 'jpeg' || file.ext == 'png' || file.ext == 'bmp'"
                class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
              <div style="font-size: 1em; width: 100%; text-align: center; font-weight: 800; display: flex;
                  align-items: center;">
                <span style="overflow-wrap:anywhere">{{ file.name }}</span>
              </div>
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="previewHandle(file)" title="预览">
                  <el-icon><zoom-in /></el-icon>
                </span>
                <span class="el-upload-list__item-delete" @click="downloadHandle(file)" title="下载">
                  <el-icon>
                    <Download />
                  </el-icon>
                </span>
                <span class="el-upload-list__item-delete" @click="removeHandle(file)" title="删除">
                  <el-icon>
                    <Delete />
                  </el-icon>
                </span>
              </span>
            </template>
          </el-upload>
        </div>
      </el-tab-pane>
      <el-tab-pane name="flownode">
        <template #label>
          <span> 审批记录 </span>
        </template>
  
        <div id="flownode">
          <el-timeline>
            <el-timeline-item v-for="(record, index) in records" :key="index" :timestamp="record.createDate" center
              :color='(record.actionCode == 10) ? "#79bbff" : (record.actionCode == 50) ? "#67c23a" : record.actionCode == -10 ? "#e6a23c" : record.actionCode == -50 ? "#f56c6c" : ""'
              placement="top">
              <el-card>
                <p><b>审批状态：</b>
                  [{{ record.createUserName }}]
                  <span v-if="record.actionCode == 0">草稿</span>
                  <span style="color:#79bbff" v-else-if="record.actionCode == 10">通过</span>
                  <span style="color:#67c23a" v-else-if="record.actionCode == 50">结束</span>
                  <span style="color:#e6a23c" v-else-if="record.actionCode == -10">退回</span>
                  <span style="color:#f56c6c" v-else-if="record.actionCode == -50">拒绝</span>
                  <span v-else>未知</span>
                </p>
                <p><b>审批人员：</b>{{ record.sourceUserName + ' -> ' + record.targetUserName }}</p>
                <p><b>审批动作：</b>{{ record.sourceNodeName + ' -> ' + record.targetNodeName }}</p>
                <p><b>审批意见：</b>{{ record.remark || '无' }}</p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-tab-pane>
  
      <el-tab-pane name="flowdraw">
        <template #label>
          <span> 审批流程图 </span>
        </template>
  
        <div id="flowdraw">
          <drawapp ref="drawapp1" :data="drawdata" :height="500" :width="800" :lang="lang" />
        </div>
      </el-tab-pane> -->
    </el-tabs>
</template>
<script>
import drawapp from "@/components/flowDraw";
import flowAudit from "@/views/workflow/flowAudit.vue";
import StaticDialog from "@/components/static-dialog.vue";

// import { getInstance, fetchRecords } from "@/api/workflow";
// import { fetchFileList, delFile } from "@/api/basic";
export default {
    name: "StockMaterialDetail",
    components: { StaticDialog, flowAudit, drawapp },
    data() {
        return {
            tabName: "workform",
            companys: [],
            departments: [],
            id: '',
            dict: {
                factorys: [],
                billTypes: [],
            },

            forms: { "billType": "采购金料", "materialCode": "Y999", "unitPrice": 0 },
            materials: [],

            latestMaterial: [], // 最新库存信息（历史的合计库存）

            // files: [],
            // userInfo: {},
            // records: [],
            // drawdata: {},
            // opts: {},
            // lang: "zh",
            // apiUrl: '',

            choosePayBill: {},
            choosePayForm: {}
        };
    },
    methods: {
        billTypeChange() {
            if (this.id) return;

            let that = this;
            let items = this.dict.billTypes.filter(function (item) {
                return item.value == that.forms.billType;
            });
            if (items && items.length > 0) {
                this.$kaung.fetch({ url: 'StockMaterialBill/GetBillCode?BillType=' + items[0].value + '&Prev=' + items[0].attribute, method: 'get' })
                    .then((res) => {
                        that.forms.billCode = 'C-' + res.data;
                        that.forms.billDate = that.$util.fmtDate(new Date());
                        that.forms.userName = that.$store.getters.getUserInfo.userName;

                        this.materialChange();
                    });
            }
        },
        companyChange() {
            this.choosePayBill = {};
            this.forms.payBillCode = '';
            this.forms.billCode = '';
            this.forms.payBillAmount = '';
            this.forms.billDate = '';

            this.forms.departments = null;
            this.departments = [];
            var that = this;
            this.$kaung.departments(this.forms.companyId).then((res) => {
                that.departments = res;
            });
        },
        materialChange() {
            if ((this.id || '').length > 0) return;

            let that = this;
            this.forms.departments = this.forms.departments || [];

            that.materials = that.materials.filter(item => this.forms.departments.indexOf(item.departmentId) > -1);
            this.forms.departments.forEach(elementId => {
                let department = that.departments.filter(item => item.id == elementId)[0];
                //let factory = that.forms.factoryCode ? that.dict.factorys.filter(item => item.value == that.forms.factoryCode)[0] : {};
                let metal = that.forms.materialCode ? that.dict.metals.filter(item => item.name == that.forms.materialCode)[0] : {};

                let entitys = that.materials.filter(item => item.departmentId == elementId);
                let entity = (entitys && entitys.length > 0) ? entitys[0] : {};

                console.log('entity', entity);
                //let factory = entity.factoryName ? that.dict.factorys.filter(item => item.value == entity.factoryName)[0] : {};

                let material = {
                    companyId: entity.companyId || that.forms.companyId,
                    departmentId: entity.departmentId || department.id,
                    departmentName: entity.departmentName || department.departmentName,
                    billType: that.forms.billType,
                    factoryName: '本地仓',//factory.value || entity.factoryName,
                    factoryCode: '本地仓',//factory.name || entity.factoryCode,
                    materialName: metal.value || entity.materialName,
                    materialCode: metal.name || entity.materialCode,
                    unitPrice: parseFloat((that.forms.unitPrice || 0).toFixed(2)),
                    stockNumber: parseFloat((entity.stockNumber || 0).toFixed(2)),
                    stockPrice: parseFloat((that.forms.unitPrice || 0) * (entity.stockNumber || 0)).toFixed(2),
                };
                //console.log('that.forms', that.forms);

                that.materials = that.materials.filter(item => item.departmentId != elementId);
                that.materials.push(material);

                this.materialInfo(material);
            });
        },
        materialInfo(material) {
            if (!material || !material.companyId || !material.materialCode || !material.factoryCode)
                return;

            let lMaterials = this.latestMaterial
                .filter(item => item.companyId == material.companyId
                    && item.departmentId == material.departmentId
                    && item.factoryCode == material.factoryCode
                    && item.materialCode == material.materialCode);
            if (lMaterials.length == 0) {
                this.$kaung.fetch({
                    url: 'StockMaterialBill/GetLatestMaterial',
                    method: 'get',
                    params: {
                        CompanyId: material.companyId,
                        DepartmentId: material.departmentId,
                        FactoryCode: material.factoryCode,
                        MaterialCode: material.materialCode
                    }
                })
                    .then((res) => {
                        if (res.code == 200 && res.data) {
                            let lMaterial = res.data;
                            lMaterial.companyId = lMaterial.companyID;
                            lMaterial.departmentId = lMaterial.departmentID;

                            this.latestMaterial.push(lMaterial);
                            this.bindMaterial(material);
                        }
                    });
            } else {
                this.bindMaterial(material);
            }
        },
        //在历史库中查找对应的最新金料信息，和当前选择的关联
        bindMaterial(material) {
            let lMaterials = this.latestMaterial
                .filter(item => item.companyId == material.companyId
                    && item.departmentId == material.departmentId
                    && item.factoryCode == material.factoryCode
                    && item.materialCode == material.materialCode);

            let dItem = this.materials.filter(item => item.departmentId == material.departmentId)[0];
            //dItem.originID = lMaterials[0].id;
            dItem.remainNumber = lMaterials[0].remainNumber;
            dItem.remainPrice = lMaterials[0].remainPrice;
        },
        saveEvent() {
            if ((this.forms.billType || '').length == 0) {
                this.$message.error('请选择操作类型');
                return;
            }
            if ((this.forms.companyId || '').length == 0 || this.forms.departments.length == 0) {
                this.$message.error('请选择所属公司以及对应的部门渠道');
                return;
            }
            if ((this.forms.payBillCode || '').length == 0) {
                this.$message.error('请选择关联的付款单号');
                return;
            }

            let factory = this.dict.factorys.filter(q => q.value == this.forms.factoryName)[0];
            if (!factory) {
                this.$message.error('请选择金料工厂信息');
                return;
            }
            this.forms.factoryCode = factory.value;

            if ((this.forms.factoryCode || '').length == 0) {
                this.$message.error('请选择金料工厂信息');
                return;
            }
            if ((this.forms.materialCode || '').length == 0) {
                this.$message.error('请选择金料/材质类型');
                return;
            }
            if ((this.forms.totalNumber || 0) <= 0 || (this.forms.unitPrice || 0) <= 0) {
                this.$message.error('请填写金单价及总克重/数量');
                return;
            }

            let totalNumber = 0.0;
            this.materials.forEach(item => {
                if ((item.stockNumber || 0) <= 0) {
                    this.$message.error('请填写明细的操作克重/数量');
                    return;
                }
                totalNumber += item.stockNumber;
            });
            if (totalNumber != this.forms.totalNumber) {
                this.$message.error('明细的操作克重/数量总和与总克重/数量不一致');
                return;
            }
            if (this.forms.payBillAmount && (this.forms.payBillAmount * 1.00).toFixed(2) != (this.forms.totalNumber * this.forms.unitPrice).toFixed(2)) {
                this.$message.error('金料总金额与付款单金额不一致');
                return;
            }

            if (this.latestMaterial.length == 0) {
                this.$message.error('获取工厂历史明细信息失败，请检查后重试');
                return;
            }

            let departmentIds = []; let departmentNames = [];
            this.forms.departments.forEach(elementId => {
                departmentIds.push(elementId);
                departmentNames.push(this.departments.filter(item => item.id == elementId)[0].departmentName);
            });
            this.forms.departmentIds = departmentIds.join(',');
            this.forms.departmentNames = departmentNames.join(',');

            let metal = this.forms.materialCode ? this.dict.metals.filter(item => item.name == this.forms.materialCode)[0] : {};
            this.forms.materialName = metal.value;

            let that = this;
            this.$refs.forms.validate((valid) => {
                if (!valid) return;

                let dtos = {
                    bill: this.forms,
                    details: this.materials,
                };
                this.$kaung.fetch({
                    url: 'StockMaterialBill/SaveForm',
                    method: 'post',
                    data: dtos
                })
                    .then((res) => {
                        that.$message({ type: res.type, message: res.content });
                        if (res.code == 200) {
                            that.forms = res.data.bill;
                            that.materials = res.data.details;

                            that.$router.push({ path: "index", query: { id: that.forms.id } });
                        }
                    });
            });
        },
        fundEvent() {
            this.$confirm("确认以上单据信息无误，点击保存并归档？", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", })
                .then(() => {
                    let that = this;
                    this.$kaung.fetch({
                        url: 'StockMaterialBill/FundForm?id=' + this.forms.id,
                        method: 'post'
                    })
                        .then((res) => {
                            that.$message({ type: res.type, message: res.content });
                            if (res.code == 200) {
                                that.forms = res.data;
                            }
                        });
                });
        },


        // uploadHandleBefore(file) {
        //   if (!(this.opts.uniqueCode || this.forms.billCode))
        //     return false;

        //   //允许所有人在流程中上传文件
        //   //console.log(this.opts);
        //   //如果是管理员角色可以新补充上传，无需草稿状态才能上传
        //   // let role = this.$store.state.userInfo.roles.filter(x => x.toLowerCase() == 'admin');
        //   // if (role.length == 0 && (this.opts.status != 0 && this.opts.status != -10)) {
        //   //   this.$message({ type: 'info', message: '不允许上传正在审批过程中的单据', });
        //   //   return false;
        //   // }
        // },
        // removeHandle(file) {
        //   let role = this.$store.state.userInfo.roles.filter(x => x.toLowerCase() == 'admin');
        //   if (role.length == 0 && (this.opts.status != 0 && this.opts.status != -10)) {
        //     this.$message({ type: 'info', message: '不允许删除正在审批过程中的单据', });
        //     return false;
        //   }

        //   delFile(file.id).then((res) => {
        //     this.$message({ type: res.type, message: res.content });
        //     this.getFileList();
        //   });
        //   //this.files = this.files.filter(q => q.id != file.id);
        // },
        // uploadHandleSuccess(res, file, fileList) {
        //   this.$message({ type: res.type, message: res.content, });
        //   fileList = [];
        //   this.getFileList();
        //   // if (res.code == 200) {
        //   // } else {
        //   //   fileList = fileList.pop()
        //   // }
        // },
        // previewHandle(res) {
        //   //window.open(res.url);
        //   window.open('/preview?id=' + res.id);
        // },
        // downloadHandle(res) {
        //   window.open(res.url);
        // },
        // getFileList() {
        //   fetchFileList((this.opts.uniqueCode || this.forms.billCode)).then((res) => {
        //     this.opts.files = res.data;
        //   });
        // },
        // getRecords(id) {
        //   fetchRecords(id).then((res) => {
        //     this.records = res.data;
        //   });
        // },

        // getFlowDraw() {
        //   //加载已经保存过的数据
        //   getInstance(this.id).then((res) => {
        //     if (res.code === 200) {
        //       this.opts = res.data;

        //       this.getFileList();
        //       this.getRecords(this.opts.id);
        //       this.drawdata = JSON.parse(res.data.flowData);
        //     }
        //   });
        // },


        //搜索归属的SPU（请求后台数据）
        searchPayBillAsync(queryString, callback) {
            console.log(queryString, callback);

            this.$kaung.fetch({
                url: 'StockMaterialBill/QueryWorkFlow',
                params: { keyword: this.choosePayBill.value, flowCode: 'flow-payreceipt', companyId: this.forms.companyId },
            }).then((res) => {
                let inputOptions = [];
                res.data.forEach(function (item) {
                    inputOptions.push({
                        value: '【' + item.billCode + '】' + item.flowName + ' - ' + item.formDesc,
                        ...item,
                    });
                });

                callback(inputOptions);
            });
        },
        //选择选中事件
        choosePayBillHandle(item) {
            //console.log(JSON.parse(item.formData));

            this.choosePayBill = item;
            this.choosePayForm = JSON.parse(item.formData);

            this.forms.payBillCode = item.billCode;
            //this.forms.billCode = 'G-' + item.billCode;
            this.forms.payBillAmount = this.choosePayForm.subtotal;
            this.forms.billDate = this.$util.fmtDate(new Date());
            this.forms.userName = this.$store.getters.getUserInfo.userName;
        },
    },
    mounted() {
        let that = this;

        this.id = this.$route.query.id || '';
        this.forms.billType = this.$route.query.billType || this.forms.billType;
        if (this.id) {
            this.$kaung.fetch({ url: 'StockMaterialBill/GetBillDto?id=' + this.id, method: 'get' })
                .then((res) => {
                    this.forms = res.data.bill;
                    this.id = this.forms.id;
                    this.materials = res.data.details;

                    this.forms.companyId = this.forms.companyID;
                    //this.companyChange();
                    this.forms.departments = this.forms.departmentIds.split(',');

                    //this.getFlowDraw();
                });
        }
    },
    created() {
        this.apiUrl = process.env.VUE_APP_BASEURL;

        this.$kaung.dictionary("stock", "factory").then((res) => { this.dict.factorys = res.filter(q => !!q.value); });
        this.$kaung.dictionary("stock", "metal").then((res) => { this.dict.metals = res; });
        this.$kaung.dictionary("stock", "material").then((res) => { this.dict.billTypes = res; })
        // .then(() => {
        //   if (!this.id) this.billTypeChange();
        // });

        this.$kaung.companys().then((res) => {
            this.companys = res;
            this.forms.companyId = this.companys[0].id;
            this.companyChange();

            this.billTypeChange();
        });
    },
    watch: {

    },
};
</script>
<style scoped>
.form-title {
    text-align: center;
    margin: 10px auto;
    padding-bottom: 20px;
    color: #000;
    font-size: 1.8em;
    font-weight: 400;
    border-bottom: 4px double #000;
    max-width: 410px;
    letter-spacing: 25px;
}
</style>
